/**
 * Image Gallery Component
 *
 * Image carousel for listing detail
 */

import { useState } from "react";

interface Props {
  images: string[];
}

export function ImageGallery({ images }: Props) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!images || images.length === 0) {
    return (
      <div className="w-full h-96 bg-slate-200 flex items-center justify-center text-slate-500">
        No images available
      </div>
    );
  }

  const currentImage = images[selectedIndex];

  return (
    <div className="space-y-4">
      {/* Main Image */}
      <div className="bg-slate-100 rounded-lg overflow-hidden">
        <img
          src={currentImage}
          alt="Boat listing"
          className="w-full h-96 object-cover"
        />
      </div>

      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-2">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition ${
                index === selectedIndex ? "border-accent" : "border-ash hover:border-slate-400"
              }`}
            >
              <img
                src={image}
                alt={`Boat listing ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}

      {/* Image Counter */}
      <div className="text-sm text-slate-600 text-center">
        {selectedIndex + 1} / {images.length}
      </div>
    </div>
  );
}
